import React, { useState } from "react";
import { useSelector } from "react-redux";
import Style from "./evidencePhotos.module.scss";
import { useTranslation } from "react-i18next";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { RootState } from "../reducers";
import GenericMobileCard from "./general/genericMobileCard";

const EvidencePhotos = () => {
  const ticket = useSelector((state: RootState) => state.ticket.ticket);
  const [media] = useState(() => {
        if (ticket.imageUrls && ticket.imageUrls.length > 0) { // Backend will return imageUrls and videoUrls only with evidence key provided
          const imageUrls = ticket.imageUrls || [];
          const videoUrls = ticket.videoUrls || [];
          return [...imageUrls, ...videoUrls];
        } else {
          return ticket.blurredImageUrls || [];
        }
      });
  const { t } = useTranslation();

  const mapMediaToGalleryItems = () => {
    return media.map((item) => {
      const isVideo = item.endsWith(".mp4") || item.endsWith(".webm");

      return {
        original: item,
        thumbnail: isVideo ? undefined : item,
        renderItem: () => {
          if (isVideo) {
            return (
              <div
                style={{
                  width: "100%",
                  height: "60vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#000",
                }}
              >
                <video
                  controls
                  playsInline
                  style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                  }}
                  src={item}
                  onLoadedMetadata={(e) => {
                    const video = e.currentTarget;
                    video.style.width = video.videoWidth ? "100%" : "auto";
                  }}
                />
              </div>
            );
          } else {
            return <img src={item} alt="" style={{ width: "100%" }} />;
          }
        },
      };
    });
  };

  return (
    <GenericMobileCard title={t("Evidence.photos").toString()}>
      <div className={Style.formMobile__imgContainer}>
        <ImageGallery
          items={mapMediaToGalleryItems()}
          showPlayButton={false}
          showFullscreenButton={false}
          lazyLoad={true}
        />
      </div>
    </GenericMobileCard>
  );
};

export default EvidencePhotos;
